import { render, staticRenderFns } from "./messageTable.vue?vue&type=template&id=0d01f2db&scoped=true"
import script from "./messageTable.vue?vue&type=script&lang=js"
export * from "./messageTable.vue?vue&type=script&lang=js"
import style0 from "./messageTable.vue?vue&type=style&index=0&id=0d01f2db&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01f2db",
  null
  
)

export default component.exports